<template>
	<component :is="componentName" v-bind="$attrs" :pass="pass"></component>
</template>

<script>
import HeroPassImage from "./Components/HeroPassImage";

export default {
	name: 'PassImage',
	components: {
		HeroPassImage
	},
	props: {
		pass: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			default: "Hero"
		}
	},
	computed: {
		componentName() {
			return `${this.type}PassImage`;
		}
	}
};
</script>
